import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { OtpServiceService } from '../otp-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-delete-profile',
  templateUrl: './delete-profile.component.html',
  styleUrls: ['./delete-profile.component.scss']
})
export class DeleteProfileComponent {
  hide = true;

  constructor(
    private otpServiceService: OtpServiceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private spinnerService: SpinnerService
  ) { }

  deleteProfile(deleteProfileForm: NgForm) {
    this.spinnerService.showSpinner$.next(true);
    this.otpServiceService.deleteProfile(deleteProfileForm.form.value.phone, deleteProfileForm.form.value.otp).subscribe({
      next: () => {
        this.snackBar.open("Success", 'Done');
        this.router.navigate(['/login']);
        this.spinnerService.showSpinner$.next(false);
      },
      error: (err) => {
        this.snackBar.open(err.message, 'Error');
        this.spinnerService.showSpinner$.next(false);
      },
    });
  }
}
